import { inject, Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { STORAGE } from "../types/constants/appconstants";

@Injectable({
    providedIn: "root"
})
export class PCPCrypto {
    private storage = inject(STORAGE);
    private key: string;
    
    constructor() {
        this.key = this.md5Hash(this.storage);
    }

    encrypt(data: any): string {
        return CryptoJS.AES.encrypt(data, this.key).toString();
    }

    decrypt(data: any): string {
        return CryptoJS.AES.decrypt(data, this.key).toString(CryptoJS.enc.Utf8);
    }

    shaHash(key: string): string {
        var key = CryptoJS.SHA256(key, this.key);
        return key.toString();
    }

    md5Hash(key: string): string {
        var hashedKey = CryptoJS.MD5(key);;
        return hashedKey.toString();
    }
}